import React from 'react';

import { AuthenticationLayout } from 'components/Layout/AuthenticationLayout';

import { ForgotPasswordForm } from 'components/Authentication/Forms';

export function ForgotPassword() {
  return (
    <AuthenticationLayout heading="Forgot Password">
      <ForgotPasswordForm />
    </AuthenticationLayout>
  );
}
